export enum DataSyncProvidersEnum {
	Quba = "Quba",
}
